module.exports = __webpack_public_path__ + "img/bg-flex-enrollment.94289598.jpg";